import { Suspense } from "react";
// eslint-disable-next-line import/no-restricted-paths
import { useImage } from "react-image";

import { cn } from "@/lib/chillnn/cn";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

type Props = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

const ImageComponent = ({ className, src: _src, alt, ...props }: Props) => {
	const fallbackImage = DUMMY_IMAGE.url;
	const { src } = useImage({ srcList: [_src || fallbackImage, fallbackImage] });

	return <img src={src} alt={alt} className={cn(className)} {...props} />;
};

export const Image = (props: Props) => {
	return (
		<Suspense
			fallback={
				<div
					className={cn(
						"aspect-auto min-h-12 min-w-12 rounded",
						props.className,
						"animate-pulse bg-zinc-200",
					)}
				/>
			}
		>
			<ImageComponent {...props} />
		</Suspense>
	);
};
